import { combineReducers } from '@reduxjs/toolkit';
import login from './loginSlice';
import register from './registerSlice';
import user from './userSlice';
import newpwd from './newpwdSlice';

const authReducers = combineReducers({
	user,
	login,
	register,
	newpwd
});

export default authReducers;
